export const STORAGE_KEY_ACTIVE_TAB = 'assetTabs_activeTab';
export const STORAGE_KEY_TABS = 'assetTabs_tabs';